import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import routes from './constants/routes';
import AcademicYears from './modules/AcademicYears/AcademicYears';
import ConsolidatedMarksReport from './modules/ConsolidatedMarksReport';
import ExamsCrudContainer from './modules/Exams/ExamsCrudContainer';
import GradeScale from './modules/GradeScales/GradeScale';
import AdminDashboard from './modules/HomePage/AdminDashboard';
import AdminLogin from './modules/Login/AdminLoginScreen/AdminLogin';
import AdminOtpScreenContainer from './modules/Login/AdminOtpScreen/AdminOtpScreenContainer';
import LogoutPage from './modules/Logout';
import PendingFeeReport from './modules/PendingFeeReport/PendingFeeReportContainer';
import AuthGate from './modules/PrivateRoute/admin';
import SchoolListing from './modules/SchoolManagement/SchoolListing';
import SchoolStructureForm from './modules/SchoolStructure/SchoolStructureForm';
import OrgSettingForm from './modules/SchoolConfig/OrgSettingForm';
import PaymentConfig from './modules/PaymentConfig/PaymentConfig';
import LateFeeConfig from './modules/LateFeeConfig/LateFeeConfig';
import ScoringTypesContainer from './modules/ScoringTypes';
import SubjectContainer from './modules/Subjects';
import AcademicTermsContainer from './modules/AcademicTerms';
import TermsContainer from './modules/Terms';
import ImportRollOverUsersContainer from './modules/UploadCsv/ImportRolloverUsersContainer';
import './App.css';
import ElectivesAssignment from './modules/ElectivesAssignment/ElectivesAssignment';
import Hashtags from './modules/Hashtags/HashtagsPage';
import AdminUsers from './modules/AdminUsers/AdminUsers';
import MarksAnalytics from './modules/MarksAnalytics/MarksAnalytics';
import CashFlowStatementContainer from './modules/CashFlowStatement';
import ChequeStatusUpdate from './modules/ChequeStatusUpdate/ChequeStatusUpdate';
import SearchStudentFeeEntryContainer from './modules/SearchStudentFeeEntry';
import TransactionStatusUpdate from './modules/TransactionStatusUpdate/TransactionStatusUpdate';
import StaffAttendancePage from './modules/StaffAttendance/StaffAttendancePage';
import StaffAttendanceReportPage from './modules/StaffAttendanceReport/StaffAttendanceReportPage';

const App = () => {
  return (
    <Router>
      <AuthGate>
        <Routes>
          <Route index element={<AdminLogin />} />
          <Route path={routes.ADMIN_LOGIN} element={<AdminLogin />} />
          <Route
            path={routes.ADMIN_LOGIN_OTP}
            element={<AdminOtpScreenContainer />}
          />
          <Route path={routes.ADMIN_HOME} element={<AdminDashboard />} />
          <Route path={routes.LOGOUT} element={<LogoutPage />} />
          <Route path={routes.SCHOOL} element={<SchoolListing />} />
          <Route path={routes.SCHOOL_CONFIG} element={<OrgSettingForm />} />
          <Route
            path={routes.SCHOOL_STRUCTURE}
            element={<SchoolStructureForm />}
          />
          <Route path={routes.PAYMENT_CONFIG} element={<PaymentConfig />} />
          <Route
            path={routes.SCORING_TYPE}
            element={<ScoringTypesContainer />}
          />
          <Route
            path={routes.PENDING_FEE_REPORT}
            element={<PendingFeeReport />}
          />

          <Route
            path={routes.CASH_FLOW_STATEMENT}
            element={<CashFlowStatementContainer />}
          />
          <Route path={routes.LATE_FEE_CONFIG} element={<LateFeeConfig />} />
          <Route path={routes.TERMS} element={<TermsContainer />} />
          <Route path={routes.EXAMS} element={<ExamsCrudContainer />} />
          <Route
            path={routes.SEARCH_STUDENT_FEE_ENTRY}
            element={<SearchStudentFeeEntryContainer />}
          />
          <Route path={routes.TERMS} element={<TermsContainer />} />
          <Route path={routes.EXAMS} element={<ExamsCrudContainer />} />
          <Route path={routes.GRADE_SCALE} element={<GradeScale />} />
          <Route path={routes.SUBJECTS} element={<SubjectContainer />} />
          <Route
            path={routes.ACADEMIC_YEAR_TERMS}
            element={<AcademicTermsContainer />}
          />
          <Route path={routes.ACADEMIC_YEARS} element={<AcademicYears />} />
          <Route
            path={routes.ELECTIVES_ASSIGNMENT}
            element={<ElectivesAssignment />}
          />
          <Route
            path={routes.IMPORT_USERS}
            element={<ImportRollOverUsersContainer />}
          />

          <Route path={routes.ADMIN_USERS} element={<AdminUsers />} />
          <Route path={routes.HASHTAGS} element={<Hashtags />} />
          <Route path={routes.MARKS_ANALYTICS} element={<MarksAnalytics />} />
          <Route
            path={routes.CONSOLIDATED_MARKS_REPORT}
            element={<ConsolidatedMarksReport />}
          />
          <Route
            path={routes.CHEQUE_STATUS_UPDATE}
            element={<ChequeStatusUpdate />}
          />
          <Route
            path={routes.TRANSACTION_STATUS_UPDATE}
            element={<TransactionStatusUpdate />}
          />

          <Route path={routes.STAFF_ATTENDANCE} element={<StaffAttendancePage />} />

          <Route
            path={routes.STAFF_ATTENDANCE_REPORT}
            element={<StaffAttendanceReportPage />}
          />

          <Route path='*' element={<div>404 Not Found</div>} />
        </Routes>
      </AuthGate>
    </Router>
  );
};

export default App;
